import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material';

export const GradientCircularProgress = ({
    gradient = ['#0C6FD3', '#01499A'],
    showProgress = false,
    ...props
}: Pick<CircularProgressProps, 'size' | 'value' | 'sx' | 'thickness' | 'variant' | 'disableShrink'> & {
    gradient?: [string, string];
    showProgress?: boolean;
}) => (
    <Box position="relative" width="fit-content">
        <CircularProgress
            thickness={3}
            {...props}
            variant="determinate"
            sx={{
                ...props.sx,
                color: '#919EAB29',
            }}
            value={100}
        />
        <svg width={0} height={0}>
            <defs>
                <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={gradient[0]} />
                    <stop offset="100%" stopColor={gradient[1]} />
                </linearGradient>
            </defs>
        </svg>
        <CircularProgress
            thickness={3}
            variant="determinate"
            {...props}
            disableShrink
            sx={{
                ...props.sx,
                'svg circle': { stroke: 'url(#my_gradient)', strokeLinecap: 'round' },
                position: 'absolute',
                left: 0,
                top: 0,
            }}
        />
        {showProgress && (
            <Box
                position="absolute"
                bottom={0}
                left="50%"
                px="8px"
                py="6.75px"
                borderRadius="16px"
                lineHeight="16.19px"
                sx={{
                    transform: 'translateX(-50%)',
                    background: `linear-gradient(90deg, ${gradient[1]} 0%, ${gradient[0]} 100%)`,
                }}
                zIndex={1}
            >
                <Typography fontSize={10.8} color="white" fontWeight={500}>
                    {props.value}%
                </Typography>
            </Box>
        )}
    </Box>
);
